import { ModalRouteService } from 'app/services/modal-route.service';
import { AdServicesService } from '../../../services/ad-services.service';
import { BbFilterConfiguration } from '../../shared/bb-filters/bb-filters.component';
import { TableRow, BbTableSelectOption } from '../../../services/bb-table.service';
import { Subscription } from 'rxjs';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AbstractListComponent } from '../../shared/abstract-list.component';
import { FilterSetService } from '../../../services/filter-set.service';
import { BbTableService } from '../../../services/bb-table.service';

@Component({
	selector: 'auction-list',
	templateUrl: './auction-list.component.html',
	styleUrls: ['./auction-list.component.scss'],
	providers: [BbTableService, FilterSetService],
})

export class AuctionListComponent extends AbstractListComponent implements OnInit, OnDestroy {
	putRightSub: Subscription;
	putRight: boolean;
	filterConfig: BbFilterConfiguration;

	constructor(
		protected bbTableService: BbTableService,
		public modalRouteService: ModalRouteService,
		public adServicesService: AdServicesService,
	) {
		super(bbTableService);

		this.listConfiguration = {
			name: 'auction',
			basePath: '/adservices/auction',
			activePath: '/adservices/auctions',
			entityTranslation: this.translate.instant('AUCTION').toLowerCase(),
			entitiesTranslation: this.translate.instant('AUCTIONS').toLowerCase()
		};

		this.filterConfig = {
			search: true,
			filters: [],
			presets: [{
				label: this.translate.instant('ALL'),
				value: 'all',
				filterSet: [],
			},
			{
				label: this.translate.instant('ACTIVE'),
				value: 'active',
				filterSet: [{
					filters: [{
						type: 'auction',
						field: 'status',
						operator: 'is',
						value: 'active'
					}]
				}],
			},
			{
				label: this.translate.instant('INACTIVE'),
				value: 'inactive',
				filterSet: [{
					filters: [{
						type: 'auction',
						field: 'status',
						operator: 'is',
						value: 'inactive'
					}]
				}],
			}]
		};
	}

	ngOnInit() {
		this.bbTableService
			.setSelect(BbTableSelectOption.none)
			.setLimit(15)
			.sort('createddate', 'desc')
			.linkToUrl();

		super.ngOnInit();

		this.subscriptions.add(
			this.bbTableService.rowsRetrievedObservable.subscribe((rows: TableRow[]) => {
				this.rows = rows;
			})
		);

		this.subscriptions.add(this.authenticationService.hasPermission('put').subscribe(hasRight => this.putRight = hasRight));
	}

	// override super doubleclick redirect:
	redirectToDetails(row: TableRow) {
		if (row && row.data && row.data.id) {
			this.router.navigate(['adservices/auction', row.data.id]);
		}
	}

	openGlobalSettings() {
		this.modalRouteService.open('globalprebidsettings', null, 'auction');
	}
}
